import uniqid from "uniqid";

import Reveal from "../Reveal/Reveal";
import { skills } from "../../data";
import "./skills.css";

const Skills = () => {
  if (!skills.length) return null;

  return (
    <section className="section skills" id="skills">
      <Reveal as="h2" className="section__title">
        Skills
      </Reveal>
      <ul className="skills__list">
        {skills.map((skill, i) => (
          <Reveal
            as="li"
            key={uniqid()}
            variant="reveal--chip"
            className="skills__reveal"
            delay={i * 40}
          >
            <span className="skills__list-item btn btn--plain">{skill}</span>
          </Reveal>
        ))}
      </ul>
    </section>
  );
};

export default Skills;
